export enum NotificationStatus {
  Read = 'read',
  Unread = 'unread',
}
